import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import WhiteBox from "@/components/WhiteBox.vue";
import ReportCollection from "../classes/ReportCollection";
import moment from "moment";
import HolidayCollection from "@/classes/HolidayCollection";
let TimeGraphs = class TimeGraphs extends Vue {
    shortDay(day) {
        return moment(day.date).format("dddd").substring(0, 3);
    }
    //checks if the date is todays date
    isToday(day) {
        return (moment(new Date()).format("YYYY-MM-DD") ===
            moment(day.date).format("YYYY-MM-DD"));
    }
    //formats a date into DD/MM
    shortDate(day) {
        return moment(day.date).format("DD/MM");
    }
    //calculates the total height for the day
    getTotalHeightForDay(dayHours) {
        const part = Number(dayHours) / 8;
        return part > 1 ? "100%" : part * 100 + "%";
    }
    // check if the day is a working day or not to set the red color for all non-working days
    isNonWorkingDay(date) {
        const holidayColl = this.$props
            .holidays;
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(date).isoWeekday() === 6 ||
            moment(date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
    //calculates the height for a specific report
    calulateReportHeight(hours, dayHours) {
        const percentage = (hours / dayHours) * 100 + "%";
        return percentage;
    }
    setBackgroundColor(report) {
        return this.$store.getters.getGlobalTariffs.getColor(report.tariffId);
    }
};
TimeGraphs = __decorate([
    Component({
        data() {
            return {
                dateInfo: null,
                //tariffs: null,
                assignedBackgrounds: [],
                colorIndex: 0,
                reports: null,
            };
        },
        props: {
            holidays: HolidayCollection,
            inReports: ReportCollection,
        },
        created() {
            this.$data.reports = this.$props.inReports;
            this.$data.dateInfo = this.$store.getters.getDateInfo;
            window.eventBus.$on("selectedMonthReportsUpdated", () => {
                const tempReports = new ReportCollection();
                tempReports.importReportObjectsFromJson(this.$store.getters.getSelectedMonthReports); //create a report collection
                if (tempReports !== undefined) {
                    this.$data.reports = tempReports;
                }
            });
            /*(window as any).eventBus.$on('loadReportsCurrent',() => {
              let emp = this.$store.getters.getLoggedInUser.userId;
                if(this.$store.getters.getImpersonatedUser !== null){
                    emp = this.$store.getters.getImpersonatedUser.userId;
                }
                const tempReports: ReportCollection = this.$store.getters.getReports[moment(this.$store.getters.getSelectedDate).format("YYYY-MM")+emp];
                if(tempReports !== undefined){
                  this.$data.reports = tempReports as ReportCollection;
                }
            });*/
        },
        components: {
            WhiteBox,
        },
    })
], TimeGraphs);
export default TimeGraphs;
